import { render } from "./CongestionLevelIcon.vue?vue&type=template&id=73bb1fb9&lang=pug"
import script from "./CongestionLevelIcon.vue?vue&type=script&lang=ts"
export * from "./CongestionLevelIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script